import { Store } from 'store/index';
import getSearchQuery from './getSearchQuery';
import getSearchSessionId from './getSearchSessionId';
import getSearchSortBy from './getSearchSortBy';
import getSearchFilters from './getSearchFilters';

const getSearchStateForHash = (store: Store) => {
  const searchQuery = getSearchQuery(store);
  const searchFilters = getSearchFilters(store);
  const searchSessionId = getSearchSessionId(store);
  const searchSortBy = getSearchSortBy(store);
  return JSON.stringify({
    searchQuery,
    searchSessionId,
    searchFilters,
    searchSortBy,
  });
};

export default getSearchStateForHash;
